import React, { useState, useRef, useEffect } from 'react';
import { useProfileWhiteIcon,painPointsToolTipIcon,painPointsUserIcon } from '../../../../components/icons/icons.jsx';
import ProfileDropdown from './profile-dropdown/profile-dropdown.jsx';

const Profile = () => {
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const modalRef = useRef(null);

  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible);
  };

  const closeDropdown = () => {
    setDropdownVisible(false);
  };

  useEffect(() => {
    const handleDocumentClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeDropdown();
      }
    };

    if (dropdownVisible) {
      document.addEventListener('click', handleDocumentClick);
    }
    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, [dropdownVisible]);
  const openUserManual = ()  => {
    window.open('/User_Manual_AI_Pains_Gains.pdf', '_blank');
  };

  return (
    <div ref={modalRef}>
      <div onClick={openUserManual} style={{float: 'left', width: '36px',height: '36px',padding: '3px',opacity: '0.5',cursor: 'pointer'}}>
        <img src={painPointsToolTipIcon} style={{width: '30px',height: '30px'}}/>
      </div>
      <div className="profile" onClick={toggleDropdown} style={{float: 'left'}}>
        <img src={useProfileWhiteIcon} alt="profile" />
      </div>
      {dropdownVisible && (
        <div className="modal" >
          <ProfileDropdown />
        </div>
      )}
    </div>
  );
};

export default Profile;
